export const FETCH_EVENTS = 'events/FETCH_EVENTS'
export const FETCH_EVENTS_STARTED = 'events/FETCH_EVENTS_STARTED'
export const FETCH_EVENTS_SUCCESS = 'events/FETCH_EVENTS_SUCCESS'
export const FETCH_EVENTS_FAILED = 'events/FETCH_EVENTS_FAILED'
